import { IAppState } from 'shared/common/state';
import { isArrayWithItems } from 'shared/utils';

export function selectIsQuickLinksAvailable(state: IAppState): boolean {
  const links = state.results.quickLinks && state.results.quickLinks.links;

  return isArrayWithItems(links) && links.some(({ offersCount }) => Boolean(offersCount));
}
